var render = function () {
  var _vm$currentRound$mono, _vm$currentRound$mono2, _vm$currentRound$mono3, _vm$currentRound$mono4, _vm$currentRound$colo, _vm$currentRound$colo2, _vm$currentRound$colo3, _vm$currentRound$colo4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'dolch-space'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "dolch-space-content",
    staticStyle: {
      "display": "flex",
      "flex-flow": "wrap-reverse",
      "justify-content": "center"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.currentRound ? _c('div', {
    staticClass: "typing-stage"
  }, [_c('p', {
    staticClass: "hidden-input"
  }, [_vm._v(_vm._s(_vm.currentRound.phrase))]), _c('div', {
    class: "td-container"
  }, [_c('color-block-text', {
    staticClass: "type-line",
    attrs: {
      "text": _vm.currentRound.phrase,
      "text-step": 0
    }
  })], 1)]) : _vm._e(), _vm.currentRound ? _c('div', {
    class: {
      'image-stage': true,
      isMobile: _vm.isMobile
    }
  }, [_c('img', {
    staticClass: "image-before",
    attrs: {
      "alt": (_vm$currentRound$mono = _vm.currentRound.monochromeImage) === null || _vm$currentRound$mono === void 0 ? void 0 : (_vm$currentRound$mono2 = _vm$currentRound$mono.image) === null || _vm$currentRound$mono2 === void 0 ? void 0 : _vm$currentRound$mono2.description,
      "src": (_vm$currentRound$mono3 = _vm.currentRound.monochromeImage) === null || _vm$currentRound$mono3 === void 0 ? void 0 : (_vm$currentRound$mono4 = _vm$currentRound$mono3.image) === null || _vm$currentRound$mono4 === void 0 ? void 0 : _vm$currentRound$mono4.src
    }
  }), _c('img', {
    staticClass: "image-after",
    attrs: {
      "alt": (_vm$currentRound$colo = _vm.currentRound.colorImage) === null || _vm$currentRound$colo === void 0 ? void 0 : (_vm$currentRound$colo2 = _vm$currentRound$colo.image) === null || _vm$currentRound$colo2 === void 0 ? void 0 : _vm$currentRound$colo2.description,
      "src": (_vm$currentRound$colo3 = _vm.currentRound.colorImage) === null || _vm$currentRound$colo3 === void 0 ? void 0 : (_vm$currentRound$colo4 = _vm$currentRound$colo3.image) === null || _vm$currentRound$colo4 === void 0 ? void 0 : _vm$currentRound$colo4.src
    }
  })]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }